// @ts-nocheck
import request from '../utils/request';
export function fetchOrderBatches(filters) {
    const params = new URLSearchParams();
    if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params.append(key, String(value));
            }
        });
    }
    const queryString = params.toString();
    const url = queryString
        ? `/api/v1/order-batches/?${queryString}`
        : '/api/v1/order-batches/';
    return request()
        .get(url)
        .send();
}
